import { Injectable } from "@angular/core";
import { environment } from "../../environments/environment";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { ToastService } from "./toast.service";
import { BehaviorSubject } from "rxjs";

@Injectable()
export class UserService {

  private base_url = `${environment.API_URL}/`;
  
  private token = localStorage.getItem("token");
  private headers = new HttpHeaders().set("Authorization", `${this.token}`);

  private clientSubject = new BehaviorSubject<boolean>(false);
  private transporterSubject = new BehaviorSubject<boolean>(false);
  private adminSubject = new BehaviorSubject<boolean>(false);

  client$ = this.clientSubject.asObservable();
  transporter$ = this.transporterSubject.asObservable();
  admin$ = this.adminSubject.asObservable();

  constructor(
    private http: HttpClient,
    private toast: ToastService
  ) { }

  setClient(isClient: boolean) {
    this.clientSubject.next(isClient);
  }

  setTransporter(isTransporter: boolean) {
    this.transporterSubject.next(isTransporter);
  }

  setAdmin(isAdmin: boolean) {
    this.adminSubject.next(isAdmin);
  }
  
  //get one user
  getUser(id: number) {
    return this.http
      .get(this.base_url + `users/${id}`, { headers: this.headers })
      .map((res) => JSON.parse(JSON.stringify(res)));
  }

  //get list of users
  getUsers() {
    return this.http
      .get(this.base_url+'users/', { headers: this.headers })
      .map((res) => JSON.parse(JSON.stringify(res)));
  }

  //delete an user 
  deleteUser(id: number) {
    return this.http
      .delete(this.base_url + `users/delete/${id}`, { headers: this.headers })
      .map((res) => JSON.parse(JSON.stringify(res)));
  }

  //add an user
  addUser(params: object) {
    return this.http.post(this.base_url + 'users/create', params, {
      headers: this.headers
    }).map((res) => {
      let response = JSON.parse(JSON.stringify(res));
      if (response == 200) {
        this.toast.success('Utilisateur ajouté', false, 'User');
      }
      if (response == 500) {
        this.toast.error('Un utilisateur ne peut pas être client et admin à la fois', false, 'User');
      }
    });
  }

  //mise a jour
  updateUser(user_id: number, params: object) {
    return this.http
      .patch(this.base_url + `users/update/${user_id}`, params, {
        headers: this.headers
      })
      .map((res) => {
        //console.log(res);
        let response = JSON.parse(JSON.stringify(res));
        if (response == 200) {
          this.toast.success('Utilisateur mis à jour', false, 'User');
        } else {
          this.toast.error('Erreur lors de la mise à jour de l\'utilisteur.', false, "User");
        }
    })
  }
}


// WEBPACK FOOTER //
// /usr/src/app/src/app/_services/user.service.ts